import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import StatusChip from '../../changelog/components/StatusChip';
import { formatDateTime } from '../../changelog/changelogAdminConfig';
import { SEND_STATUS } from '../../onboarding/onboardingAdminConfig';

function details(row) {
  if (row.status === 'skipped') return row.skip_reason_label || row.skip_reason || 'Pulado';
  if (row.status === 'failed') return `${row.attempts} ${row.attempts === 1 ? 'tentativa' : 'tentativas'}${row.error_message ? ` · ${row.error_message}` : ''}`;
  const parts = [`Enviado em ${formatDateTime(row.sent_at || row.created_at)}`];
  parts.push(row.opened_at ? `abriu em ${formatDateTime(row.opened_at)}` : 'sem abertura registrada');
  if (row.clicked_at) parts.push(`clicou em ${formatDateTime(row.clicked_at)}`);
  return parts.join(' · ');
}

/**
 * CompanyOnboardingCard - Card "E-mails de acompanhamento" da página da empresa (Admin Geral)
 *
 * O que a conta recebeu da sequência de acompanhamento, quando, se abriu e se clicou,
 * e o que foi pulado (com o motivo). Os dados vêm de `onboarding_emails` (admin/companies/get.php).
 *
 * @param {{ emails: Array }} props
 */
function CompanyOnboardingCard({ emails }) {
  const rows = Array.isArray(emails) ? emails : [];

  return (
    <Card
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        p: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        mb: 3,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ display: 'flex', color: '#5A80FB' }}>
          <MarkEmailReadOutlinedIcon fontSize="small" />
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary', fontSize: '0.9375rem' }}>
          E-mails de acompanhamento
        </Typography>
      </Box>

      {rows.length === 0 ? (
        <Typography variant="body2" color="text.secondary">Nenhum e-mail de acompanhamento para esta conta.</Typography>
      ) : (
        <Box sx={{ display: 'grid', gap: 1.5 }}>
          {rows.map((row) => (
            <Box key={row.id} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
              <StatusChip info={SEND_STATUS[row.status] || SEND_STATUS.skipped} sx={{ minWidth: 84 }} />
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>
                  {row.day !== null && row.day !== undefined ? `Dia ${row.day} · ` : ''}{row.subject || row.template_key}
                </Typography>
                <Typography variant="caption" color="text.secondary" component="div" sx={{ wordBreak: 'break-word' }}>
                  {details(row)}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Card>
  );
}

export default CompanyOnboardingCard;
